module.exports = __webpack_public_path__ + "img/snap.77d9880.png";